export default "__VITE_ASSET__ColKgX7D__"